import { Button, Row } from 'antd'
import React from 'react'
import SubHeader from 'utils/subHeader'
import 'containers/routesMaster/App.css'
import { withRouter } from 'react-router'

class AlertSetting extends React.Component { 
  
    AddKnownPlace = () => {
        this.props.history.push({
        pathname: '/alert-settings/add',
        search: this.props.location.search,
        })
    }

    showUploadPlace = () => {
        this.props.history.push({
          pathname: '/alert-settings/upload',
          search: this.props.location.search,
        })
    }

    cta = () => {
        return (
        <div>
            <Button style={{ marginLeft: 10 }} size="large" type="primary"
               onClick={this.showUploadPlace}
            >Bulk Alert Upload
            </Button>
        </div>
        )
    }

    render() {
        return (
        <Row>
            <SubHeader innerhtml={this.cta} />
              {this.props.children}
        </Row>
        )
    }
}

export default withRouter(AlertSetting)
